import { API } from '@/utilities/api';
import { $$ } from '@/utilities/helpers';
import { PinchZoom } from '@/components/pinchZoom';

/**
 * 
 *  Gallery modal functionality
 * 
 */
export class Gallery {


    /**
     * 
     * Contructor
     * 
     * @param {element} element - The gallery element
     */
    constructor(element) {

        // Needs and wants
        this.current_index = 0;
        this.gallery = element;
        this.visible = false;
        this.images = this.gallery.querySelectorAll('.js-gallery-image');

        // Initialise the suggestion box interactions
        this.init();

    }

    renderFavourites(images) {
        let html = '';
        if (images) {
            images.forEach((image) => {
                return html += /*html*/`
                <div href="" class="gallery__slides__item" data-type="Image" data-entity-type="image" data-entity-id="${image.entity_id}">
                    <div class="gallery__slides__item__image">
                        <img zoomable data-title="${image.entity_title}" draggable="false" class=" js-gallery-image" src="${image.entity_src}" width="640" height="480" loading="lazy" alt="${image.entity_title}" data-entity-type="image" data-entity-id="${image.entity_id}">
                    </div>
                    <div class="gallery__slides__item__caption">
                        <p class="smaller no-margin colour--secondary">${image.entity_title}</p>
                    </div>
                </div>`
            });
            document.querySelector('.js-my-favourite-images').innerHTML = html;
        }
        this.images = this.gallery.querySelectorAll('.js-gallery-image');
    }

    /**
     * 
     * Initialise the gallery interactions
     * 
     */
    init() {

        // Attach keyboard events to the gallery modal
        document.addEventListener('keydown', event => {
            switch (event.key) {
                case 'Esc': this.hide(); break;
                case 'Escape': this.hide(); break;
                case 'ArrowLeft': this.prev(); break;
                case 'ArrowRight': this.next(); break;
                default: break;
            }
        });

        // Attach click events to the gallery modal
        this.gallery.addEventListener('click', event => {
            switch (event.target.className || event.target.parentNode.className) {
                case 'gallery-modal__wrap__previous': this.prev(); break;
                case 'gallery-modal__wrap__next': this.next(); break;
                default: break;
            }
        });

        if (document.body.classList.contains('Toast\\Pages\\MemberDashboardPage') || document.body.classList.contains('Toast\\Pages\\FavouritesPages')) {
            API.fetch_favourites({ keep_type: 'favourite' })
                .then((response) => {
                    this.renderFavourites(response.data.filter((keep) => keep.entity_type === 'image'));
                });
        }


        // Attach click events to the gallery modal
        this.gallery.addEventListener('click', event => {
            if (this.visible) {
                // If click outside of the modal
                if (event.target.className === 'gallery-modal') this.hide();

                if (event.target.classList.contains('js-toggle-image-favourite')) {

                    let entity_id = event.target.dataset.entityId;
                    let entity_type = 'image';

                    API.toggle_favourites({ entity_id, entity_type })
                        .then((response) => {

                            event.target.classList.toggle('hearted');

                            if (response.status !== 'ok' || response.message === 401) {
                                event.target.classList.remove('hearted');
                            }

                            if (document.body.classList.contains('Toast\\Pages\\MemberDashboardPage') || document.body.classList.contains('Toast\\Pages\\FavouritesPage')) {
                                API.fetch_favourites({ keep_type: 'favourite' })
                                    .then((response) => {
                                        this.renderFavourites(response.data.filter((keep) => keep.entity_type === 'image'));
                                    });
                            }

                            // Toast.fire({
                            //     icon: (response.status === 'ok') ? 'success' : 'error',
                            //     title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to favourite images'
                            // });
                        });


                }
            }
        });

    }


    /**
     * 
     * Navigate to the next image
     * 
     */
    next() {

        // Remove the active class from the copyright element
        document.body.classList.remove('copyright-visible');

        // Update the current index
        (this.current_index === this.images.length - 1) ? this.current_index = 0 : this.current_index++;

        // Update the modal
        document.querySelector('.gallery-modal__wrap__images').innerHTML = this.image_template([...this.images][this.current_index]);


    }


    /**
     * 
     * Navigate to the previous image
     * 
     */
    prev() {

        // Remove the active class from the copyright element
        document.body.classList.remove('copyright-visible');

        // Update the current index
        (this.current_index === 0) ? this.current_index = this.images.length - 1 : this.current_index--;

        // Update the modal
        document.querySelector('.gallery-modal__wrap__images').innerHTML = this.image_template([...this.images][this.current_index]);

    }


    /**
     * 
     * Remove any pre existing gallery modals
     * 
     */
    clean() {
        document.querySelector('.gallery-modal') ? document.querySelector('.gallery-modal').remove() : null;
    }


    /**
     * 
     * Render the gallery modal to the page
     * 
     * @param {Node} image 
     */
    render(image) {

        // Set the current index
        if (image) this.current_index = [...this.images].indexOf(image);

        // Clean up any pre existing modals
        this.clean();

        // If this is a sensitive image, then we should remove the sensitive-image class
        if (image.classList.contains('sensitive-image')) {
            image.classList.remove('sensitive-image');
        }

        // Otherwise we should open the modal 
        else {

            // Append the template to the end of the page
            this.gallery.insertAdjacentHTML('beforeend', this.template());


            setTimeout(() => this.show(), 100);
        }

    }


    /**
     * 
     * Hide the gallery modal
     * 
     */
    hide() {

        // Remove the active class from the copyright element
        document.body.classList.remove('copyright-visible');

        // Remove the active class from the page
        document.body.classList.remove('gallery-modal-open');

        //Reset the zoom of the page
        window.resetZoom();

        // Set the visiblity state
        this.visible = false;
    }


    /**
     * 
     * Show the gallery modal
     * 
     */
    show() {

        // Add the active class to the page
        document.body.classList.add('gallery-modal-open');

        // Set the visiblity state
        this.visible = true;

        console.log('ZOOM PICK - IMAGES');
        if (this.zoomPick) this.zoomPick.destroy();
        this.zoomPick = new PinchZoom(document.querySelector('.gallery-modal__wrap__images__item [zoomable]'));
        
    }


    /**
     * 
     * Single image template
     * 
     * @param {Node} image 
     * @returns {String} template
     */
    image_template(image) {

        let hearted = '';

        if (window.keeps) {
            let keep = window.keeps.data?.find(keep => parseInt(keep.entity_id) === parseInt(image.dataset.id) && keep.entity_type === 'image');
            if (keep) hearted = 'hearted';
        }

        if (document.body.classList.contains('Toast\\Pages\\MemberDashboardPage') || document.body.classList.contains('Toast\\Pages\\FavouritesPage')) {
            hearted = 'hearted';
        }

        let image_source = (image.dataset.source?.includes('http')) ?
            `<a href="${image.dataset.source}" target="_blank">${image.dataset.source}</p>` :
            image.dataset.copyright;

        let keywords = (image.dataset.keywords) ? image.dataset.keywords.split(',').map((keyword, index, array) => `<a class="colour--primary" href="/images?query=${keyword}">${keyword}</a>${index < array.length - 1 ? ',' : ''}`).join(' ') : undefined;

        return /*html*/`
        <div class="gallery-modal__wrap__images__item">
            <div href="/imagedetail/${image.dataset.url}" target="_blank" class="gallery-modal__wrap__images__item__image" onclick="event.preventDefault();">
                <img zoomable draggable="false" class="[ js-gallery-image ]" src="${image.src}" width="640" height="480" loading="lazy" alt="${image.alt}">
            </div> 
            <div class="images__wrap__grid__item__heart [ js-toggle-image-favourite ] ${hearted}" data-entity-id="${image.dataset.id || image.dataset.entityId}">
                <span class="heart">
                    <img class="heart__image-1" src="/_resources/themes/mercury/dist/images/svg/heart-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <img class="heart__image-2" src="/_resources/themes/mercury/dist/images/svg/heart-full-red.svg" width="24" height="24" loading="lazy" alt="brown-heart">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" stroke="#ff5050" fill="none" fill-rule="evenodd" />
                    </svg>
                </span>
            </div>
            <div class="gallery-modal__wrap__images__item__caption">
                <div class="gallery-modal__wrap__images__item__caption__text">
                    <h3 class="colour--secondary"><b>${image.dataset.title || ''}</b></h3>
                    <p class="no-margin colour--secondary ">${image.dataset.headline || ''} ${(image.dataset.subjectCode) ? `<span style="opacity:0.5;">${image.dataset.subjectCode}</span>` : ``}</p>
                    
                </div>
                <div class="gallery-modal__wrap__images__item__caption__footer">
                ${(keywords) ? `<span class="no-margin colour--secondary smaller gallery-modal__wrap__images__item__caption__footer__keywords" style="width:100%">${keywords && `<b>Keywords:</b> ${keywords} `}</span>` : ``}
                    
                    <p class="no-margin colour--secondary smaller colour--grey-mid-dark">Source: ${image_source || ''}</p>
                    <p class="no-margin colour--secondary smaller">
                        <a href="/terms" class="colour--grey-mid-dark">Terms and conditions</a>
                        <span class="colour--grey-mid-dark">&nbsp;|&nbsp;</span>
                        <a href="#" class="colour--primary" onclick="event.preventDefault();document.body.classList.toggle('copyright-visible')">Reusing this image</a>
                    </p>
                </div>
                
            </div>
            <div class="gallery-modal__wrap__images__item__copyright">
                <div class="gallery-modal__wrap__images__item__copyright__close" onclick="document.body.classList.remove('copyright-visible')">
                    <img src="_resources/themes/mercury/dist/images/svg/close.svg" width="10" height="10" loading="lazy" alt="close">
                </div>
                <p class="colour--white no-margin" style="margin-bottom:7px !important;"><b>© DermNet.</b></p>
                <p class="colour--white smaller no-margin" >You can use or share this image if you comply with our image <a href="/image-licence">licence</a>. Please provide a link back to this page. 
               <span style="margin-top:11px !important;display:block;width:100%;">For a high resolution, unwatermarked copy contact us <a href="/permission/?image=${image.dataset.id}">here</a>. Fees apply.</span></p>
            </div>
        </div>`;
    }


    /**
     * 
     * Gallery modal template
     * 
     * @returns {String} template
     */
    template() {
        return /*html*/` 
        <div class="gallery-modal">
            <div class="gallery-modal__wrap">
                <div class="gallery-modal__wrap__close" onclick="document.body.classList.remove('gallery-modal-open');document.body.classList.remove('copyright-visible');window.resetZoom();">
                    <img src="_resources/themes/mercury/dist/images/svg/close-dark-blue.svg" width="39px" height="40px" loading="lazy" alt="close">
                </div>
                <div class="gallery-modal__wrap__images">
                    ${this.image_template([...this.images][this.current_index])}
                </div>
                ${(this.images.length > 1) ? /*html*/`
                <button class="gallery-modal__wrap__previous">
                    <img src="_resources/themes/mercury/dist/images/svg/arrow-left-medium-dark-blue.svg" width="39px" height="40px" loading="lazy" alt="Paginate to the previous image">
                </button>
                <button class="gallery-modal__wrap__next">
                    <img src="_resources/themes/mercury/dist/images/svg/arrow-right-medium-dark-blue.svg" width="39px" height="40px" loading="lazy" alt="Pagniate to the next image">
                </button>`
                : ``}
            </div>
        </div>`;
    }

}